import React from "react";

export default function RemoveChoiceIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 12.1217 17.1571 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
        fill="#92A2B1"
      />
      <path
        d="M14 10.0008C14 9.61418 13.6866 9.30078 13.3 9.30078H6.7C6.44991 9.30078 6.21883 9.4342 6.09378 9.65078C5.96874 9.86736 5.96874 10.1342 6.09378 10.3508C6.21883 10.5674 6.44991 10.7008 6.7 10.7008H13.3C13.6866 10.7008 14 10.3874 14 10.0008Z"
        fill="white"
      />
    </svg>
  );
}
